<template>
  <div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <a-tooltip placement="top">
            <template slot="title">
              <span>Crear ruta</span>
            </template>
            <button @click="openModal(false)" type="button" class="btn btn-primary btnplus mr-2 pb-1">
              <i class="fa fa-plus pt-1" />
            </button>
          </a-tooltip>
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de Rutas</strong>
              <a-button class="ml-2" type="primary" v-b-toggle.collapse-1  shape="circle" icon="search"/>
            </h5>
          </div>
        </b-row>
        <b-collapse id="collapse-1" class="mt-2">
          <b-form>
            <b-row>
              <div class="col-sm-10 col-md-4 col-lg-3 col-xl-2">
                <b-form-group id="input-group-4" label="Código:" label-for="input-4">
                  <b-form-input id="input-4" type="number" v-model="searchBar.id" placeholder="Ingrese el código"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-10 col-md-4 col-lg-3 col-xl-2">
                <b-form-group id="input-group-5" label="Descripción:" label-for="input-5">
                  <b-form-input id="input-5" v-model="searchBar.path" placeholder="Ingrese el nombre"></b-form-input>
                </b-form-group>
              </div>
            </b-row>
          </b-form>
        </b-collapse>
        <b-row>
          <div class="col">
            <b-table id="my-table" v-if="routes.length !== 0" striped hover :fields="columns" :items="routes" :per-page="pagination.perPage" :current-page="pagination.currentPage" head-variant="light" responsive>
              <template #cell(actions)="route">
                <div>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Ver información</span>
                    </template>
                    <button type="button" @click="() => linkToPermission(route.item, 0)" class="btn btn-light mr-2">
                      <i class="fa fa-eye" />
                    </button>
                  </a-tooltip>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Editar</span>
                    </template>
                    <button type="button" @click="() => openModal(true, route.item)" class="btn btn-light mr-2">
                      <i class="fa fa-pencil text-blue" />
                    </button>
                  </a-tooltip>
                  <a-tooltip placement="top">
                      <template slot="title">
                        <span>Asignar permisos</span>
                      </template>
                      <button type="button" @click="() => linkToPermission(route.item, 1)" class="btn btn-light mr-2">
                        <i class="fa fa-plus-circle" />
                      </button>
                    </a-tooltip>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Eliminar ruta</span>
                    </template>
                    <button type="button" v-on:click="deleteRoute(route.item)" class="btn btn-light mr-2">
                      <i class="fa fa-times-circle text-red" />
                    </button>
                  </a-tooltip>
                </div>
              </template>
            </b-table>
            <empty-table v-else/>
          </div>
        </b-row>
        <b-row>
          <b-col>
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.rows"
              :per-page="pagination.perPage"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
          <b-col class="text-right">
            {{ pagination.rows }} resultados
          </b-col>
        </b-row>
      </div>
    </div>
    <b-modal id="edit-route" ref="modal" :title="isEditingRoute ? 'Editar ruta' : 'Crear ruta'" hide-footer @hidden="onHidden">
      <b-form ref="todoform">
        <b-form-group id="input-group-1" label="Descripción:" label-for="input-1">
          <b-form-input id="input-1" v-model="form.description" placeholder="Ingrese la descripción"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2" label="Dirección:" label-for="input-2">
          <b-form-input id="input-2" v-model="form.path" placeholder="Ingrese la dirección"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-3" label="Tipo de petición:" label-for="input-3">
          <b-form-select
            id="input-3"
            v-model="form.httpMethod"
            :options="methods"
            required
          ></b-form-select>
        </b-form-group>
        <b-button @click="$bvModal.hide('edit-route')" variant="secondary" size="sm" class="mb-3 mt-3">Cancelar</b-button>
        <b-button @click="saveRoute()" variant="primary" class="mr-2 mb-3 mt-3">{{ isEditingRoute ? 'Actualizar' : 'Guardar' }}</b-button>
      </b-form>
    </b-modal>
    <b-modal id="route-info" ref="modal" size="md" title="Información del permiso" hide-footer>
      <b-row class="mb-3">
        <b-col xl="9">
          Permisos con esta ruta:
        </b-col>
      </b-row>
      <template v-if="selectedRoute.permissions.length > 0">
        <b-row :id="index" v-for="(item,index) in selectedRoute.permissions" v-bind:key="item.id">
          <b-col lg="9" offset-lg="1">
            * {{ item.name }}
          </b-col>
        </b-row>
      </template>
      <b-row v-else>
        <b-col lg="5">No existen permisos vinculados a esta ruta</b-col>
      </b-row>
    </b-modal>
    <b-modal id="link-to-permissions" size="md" ref="modal" :title="'Vincular ruta: ' + selectedRoute.path" hide-footer @hidden="onHidden">
      <b-container fluid>
        <b-row align-h="center" class="mb-3">
          <b-col sm="12" lg="3" class="">
            <label class="pt-2">Permiso:</label>
          </b-col>
          <b-col>
            <b-input id="input-permission" ref="permissions" v-model="searchPermission" placeholder="Ingrese el nombre del permiso"></b-input>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col cols="11" sm="11" lg="11" class="card mb-0 pt-1 pb-0" v-for="(module, index) in filteredPermissions" v-bind:key="module.id">
            <b-row>
              <b-col cols="11" sm="11">
                <b-button block class="p-0 text-left" v-b-toggle="'collapsableModule' + index" variant="link">
                  {{ module.text }} ({{ module.permissions.length }})
                </b-button>
              </b-col>
              <b-col cols="1" sm="1" lg="1" class="px-0">
                <b-button block class="p-0 text-left" v-b-toggle="'collapsableModule' + index" variant="link">
                  <i class="fa fa-chevron-down" />
                </b-button>
              </b-col>
            </b-row>
            <b-collapse
              :id="'collapsableModule' + index"
              :accordion="'moduleX'"
              role="tabpanel"
              class="mt-2"
            >
              <template v-if="module.permissions.length > 0">
                <b-row v-for="(permission, indexP) in module.permissions" v-bind:key="permission.id" style="border: 0.2px solid; border-color: #ebebeb; border-collapse: collapse;">
                  <b-col lg="10">
                    {{ permission.name }}
                  </b-col>
                  <b-col lg="1">
                    <b-form-checkbox v-model="permission.state" switch :id="indexP + 'switch' + permission.id" />
                  </b-col>
                </b-row>
              </template>
            </b-collapse>
          </b-col>
        </b-row>
        <b-row class="mt-3 mx-auto" align-h="center">
          <b-col xl="2">
            <button class="btn btn-primary" @click="saveForPermisssions()"> Guardar </button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
import apiClient2 from '@/services/axios/v2.js'
import axios from 'axios'
import emptyTable from '@/components/custom/cardEmptyList'
import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'routes',
  components: { emptyTable },
  data() {
    return {
      isEditingRoute: false,
      routes: [],
      methods: [
        { value: null, text: 'Seleccione un método' },
        { value: 'GET', text: 'GET' },
        { value: 'POST', text: 'POST' },
        { value: 'PATCH', text: 'PATCH' },
        { value: 'PUT', text: 'PUT' },
        { value: 'DELETE', text: 'DELETE' },
        { value: 'HEAD', text: 'HEAD' },
        { value: 'CONNECT', text: 'CONNECT' },
        { value: 'OPTIONS', text: 'OPTIONS' },
        { value: 'TRACE', text: 'TRACE' },
      ],
      columns: [
        { key: 'id', label: 'Código', sortable: true },
        { key: 'path', label: 'Path' },
        { key: 'httpMethod', label: 'Tipo', sortable: true },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      modules: [
        {
          value: 1,
          text: 'NOMINA',
          permissions: [],
        },
        {
          value: 2,
          text: 'SALES',
          permissions: [],
        },
        {
          value: 3,
          text: 'SU',
          permissions: [],
        },
        {
          value: 4,
          text: 'ACADEMIC',
          permissions: [],
        },
        {
          value: 5,
          text: 'CMS',
          permissions: [],
        },
        {
          value: 6,
          text: 'PARAMS',
          permissions: [],
        },
        {
          value: 7,
          text: 'USERS',
          permissions: [],
        },
        {
          value: 8,
          text: 'MATRICULAS',
          permissions: [],
        },
      ],
      searchPermission: '',
      selectedRoute: {
        id: null,
        path: '',
        permissions: [],
      },
      form: {
        id: null,
        description: '',
        path: '',
        httpMethod: null,
      },
      pagination: {
        rows: 0,
        perPage: 7,
        currentPage: 1,
      },
      searchBar: {
        id: '',
        path: '',
      },
      typingTimer: '',
    }
  },
  computed: {
    filteredPermissions: function() {
      return this.modules
        .map(module => ({
          ...module,
          permissions: module.permissions.filter(
            permission => {
              return this.slugify(permission.name.trim().toLowerCase()).match(this.slugify(this.searchPermission.trim().toLowerCase()))
            },
          ),
        }))
        .filter(module => module.permissions.length)
    },
  },
  beforeRouteEnter (to, from, next) {
    function getRoutes() {
      return apiClient2.get('/routes')
    }
    function getPermissions() {
      return apiClient2.get('/permissions')
    }
    // function getModules() {
    //   return apiClient2.get('/modules')
    // }

    axios.all([getRoutes(), getPermissions()])
      .then(axios.spread(function (routes, permissions) {
        next((vm) => {
          vm.setDataRoutes(null, routes.data.data)
          vm.setDataPermissions(null, permissions.data.data)
          // vm.setDataModules(null, modules.data)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataRoutes(err, [])
          vm.setDataPermissions(err, [])
          // vm.setDataModules(err, [])
        })
      })
  },
  watch: {
    'searchBar.id': function () {
      this.getByFields()
    },
    'searchBar.path': function () {
      this.getByFields()
    },
  },
  methods: {
    slugify: function(str) {
      var map = {
        '-': ' ',
        a: 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
        e: 'é|è|ê|ë|É|È|Ê|Ë',
        i: 'í|ì|î|ï|Í|Ì|Î|Ï',
        o: 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
        u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
        c: 'ç|Ç',
      }
      for (var pattern in map) {
        str = str.replace(new RegExp(map[pattern], 'g'), pattern)
      }
      return str
    },
    setDataRoutes (err, routes) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.routes = routes
        this.pagination.rows = this.routes.length
      }
    },
    setDataPermissions (err, permissions) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        const disabledPermissions = permissions.map((permission) => ({ ...permission, state: false }))
        this.modules = this.modules.map(module => ({
          ...module,
          permissions: disabledPermissions.filter(
            permission => {
              return permission.idModule === module.value
            },
          ),
        }))
      }
    },
    resetModules() {
      for (let i = 0; i < this.modules.length; i++) {
        if (this.modules[i].permissions.length > 0) {
          this.modules[i].permissions.forEach((permission) => {
            permission.state = false
          })
        }
      }
    },
    async onHidden (e) {
      this.form.description = ''
      this.form.path = ''
      this.form.httpMethod = null
      this.form.id = null
      await this.resetModules()
    },
    openModal(isEditingRoute, route) {
      if (isEditingRoute) {
        this.isEditingRoute = true
        this.form = { ...route }
      } else {
        this.isEditingRoute = false
      }
      this.$bvModal.show('edit-route')
    },
    async linkToPermission(route, type) {
      this.selectedRoute.id = route.id
      this.selectedRoute.path = route.path
      await apiClient2.get(`routes/${route.id}/permissions`).then(response => {
        const { permissions } = response.data.data
        this.selectedRoute.permissions = permissions
      }).catch(e => {
        console.log(e)
      })
      if (type === 0) {
        this.$bvModal.show('route-info')
      } else {
        if (this.selectedRoute.permissions.length > 0) {
          const idPermissions = this.selectedRoute.permissions.map((permission) => permission.id)
          for (let i = 0; i < this.modules.length; i++) {
            if (this.modules[i].permissions.length > 0) {
              await this.modules[i].permissions.forEach((permission) => {
                if (idPermissions.includes(permission.id)) {
                  permission.state = true
                }
              })
            }
          }
        }
        this.$bvModal.show('link-to-permissions')
      }
    },
    saveRoute() {
      if (this.isEditingRoute && this.form.id !== null) {
        apiClient2.patch(`routes/${this.form.id}`, this.form).then(response => {
          Toast.fire({
            icon: 'success',
            title: response.data.message,
          })
          this.reloadRoutes()
          this.$bvModal.hide('edit-route')
        }).catch(e => {
          console.log(e)
        })
      } else {
        apiClient2.post('routes', this.form).then(response => {
          Toast.fire({
            icon: 'success',
            title: response.data.message,
          })
          this.reloadRoutes()
          this.$bvModal.hide('edit-route')
        }).catch(e => {
          console.log(e)
        })
      }
    },
    deleteRoute(route) {
      Swal.fire({
        title: 'Confirmar eliminación',
        text: '¿Esta seguro de que desea eliminar la ruta ' + route.path + '? \n Se eliminará de todos los registros que usen este permiso',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          apiClient2.delete(`routes/${route.id}`).then(response => {
            Toast.fire({
              icon: 'success',
              title: response.data.message,
            })
            this.reloadRoutes()
          }).catch(e => {
            console.log(e)
          })
        }
      })
    },
    reloadRoutes() {
      apiClient2.get('/routes').then(response => {
        this.setDataRoutes(null, response.data)
      })
    },
    saveForPermisssions() {
      console.log(this.selectedRoute.permissions)
      const hadPermissions = (this.selectedRoute.permissions.length > 0)
      const previousPermissions = this.selectedRoute.permissions.map(permission => permission.id)
      const inputPermission = this.modules.flatMap(module =>
        module.permissions
          .filter(permission => permission.state === true)
          .map(permission => permission.id),
      )
      // Roles eliminados
      if (hadPermissions) {
        const deletedPermissions = previousPermissions.filter(route => !inputPermission.includes(route))
        if (deletedPermissions.length > 0) {
          apiClient2.patch(`routes/${this.selectedRoute.id}/permissions`, { permissions: deletedPermissions }).then(response => {
            Toast.fire({
              icon: 'success',
              title: response.data.message,
            })
          }).catch(e => {
            console.log(e)
          })
        }
      }
      // Roles nuevos
      const newPermissions = inputPermission.filter(route => !previousPermissions.includes(route))
      if (newPermissions.length > 0) {
        apiClient2.post(`routes/${this.selectedRoute.id}/permissions`, { permissions: newPermissions }).then(response => {
          Toast.fire({
            icon: 'success',
            title: response.data.message,
          })
        }).catch(e => {
          console.log(e)
        })
      }
      this.$bvModal.hide('link-to-permissions')
    },
    getByFields() {
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => { this.search() }, 500)
    },
    async search() {
      await apiClient2.get('/routes', { params: { sentParams: this.searchBar } }).then(response => {
        this.setDataRoutes(null, response.data)
      })
    },
  },
}
</script>
<style>
  .btnplus {
    position: absolute;
    right:5em;
    z-index:10;
    border-radius: 50%;
  }
</style>
